import actionTypes from 'constants/actionTypes'


type SelectionAction = {
  type?: string
}

type NextFn = (action: SelectionAction) => unknown

type LegacyDocumentSelection = {
  empty?: () => void
}

type LegacyDocument = Document & {
  selection?: LegacyDocumentSelection
}


export default () => (next: NextFn) => (action: SelectionAction) => {
  if (action.type === actionTypes.GRAPH.EDIT.STOP) {
    const selection = window.getSelection?.()
    selection?.empty?.()
    selection?.removeAllRanges?.()
    ;(document as LegacyDocument).selection?.empty?.()
  }
  return next(action)
}
